import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

/**
 * RA 10173 (Data Privacy Act) requires a privacy notice published
 * before collecting personal data. This page renders the policy at
 * `/privacy` and is linked from the marketing footer + signup flow.
 *
 * The actual legal text lives in src/locales/{en,fil}/common.json under
 * `legal.privacy_*` keys so it can be translated and updated without
 * touching code. Real launch content should be reviewed by a PH
 * data-privacy lawyer before publication.
 */
export default function PrivacyPage() {
  const { t } = useTranslation();
  return (
    <div className="min-h-screen bg-surface-page">
      <header className="border-b border-slate-200 bg-surface">
        <div className="mx-auto flex max-w-3xl items-center justify-between px-6 py-4">
          <Link
            to="/"
            className="text-xl font-bold text-slate-900 hover:text-primary"
          >
            {t("app.title")}
          </Link>
        </div>
      </header>
      <main className="mx-auto max-w-3xl px-6 py-12 prose prose-slate">
        <h1>{t("legal.privacy_title")}</h1>
        <p className="text-sm text-slate-500">{t("legal.last_updated")}</p>
        <p className="lead">{t("legal.privacy_lead")}</p>

        <h2>{t("legal.privacy_what_we_collect_title")}</h2>
        <p>{t("legal.privacy_what_we_collect_body")}</p>

        <h2>{t("legal.privacy_why_title")}</h2>
        <p>{t("legal.privacy_why_body")}</p>

        <h2>{t("legal.privacy_retention_title")}</h2>
        <p>{t("legal.privacy_retention_body")}</p>

        <h2>{t("legal.privacy_rights_title")}</h2>
        <p>{t("legal.privacy_rights_body")}</p>

        <h2>{t("legal.privacy_dpo_title")}</h2>
        <p>{t("legal.privacy_dpo_body")}</p>

        <p className="text-sm text-slate-500">{t("legal.draft_warning")}</p>
      </main>
    </div>
  );
}
